<template>
  <div class="custom-scroller" ref="scrollerRef">
    <div class="scroller-thumb" ref="thumbRef">
      <div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineExpose, ref } from "vue";

const scrollerRef = ref(null);
const thumbRef = ref(null);

defineExpose({
  scrollerRef,
  thumbRef,
});
</script>
